<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
const props = defineProps({
  brand: {
    type: String,
    required: true
  },
  model: {
    type: String,
    required: true
  }
});
defineEmits(["cancel", "confirm"]);
const { t } = useI18n();
const title = computed(() => {
  return t("user_vehicles.titles.delete", {
    vehicle: props.brand + " " + props.model
  });
});
</script>

<template>
    <div class="w-full flex flex-col items-center gap-6">
        <div class="w-full flex flex-col items-center gap-2">
            <IconTrash class="size-12 text-icon-secondary-negative" />
            <span
                class="text-[17px] 425:text-[22px] text-header-dark font-bold leading-5 425:leading-[25px]"
            >
                {{ title }}
            </span>
            <span
                class="text-[15px] 425:text-[17px] text-gray-l-600 font-normal leading-[18px] 425:leading-5"
            >
                {{ $t("user_vehicles.delete.subtitle") }}
            </span>
        </div>

        <div class="w-full flex gap-2 items-center justify-center">
            <ChargemapB2CButton
                data-testid="cancel"
                class="w-full"
                type="secondary"
                size="large"
                @click="$emit('cancel')"
            >
                {{ $t("user_vehicles.delete.cancel") }}
            </ChargemapB2CButton>
            <ChargemapB2CButton
                data-testid="confirm"
                class="w-full"
                type="secondary"
                size="large"
                variant="red"
                @click="$emit('confirm')"
            >
                {{ $t("user_vehicles.delete.confirm") }}
            </ChargemapB2CButton>
        </div>
    </div>
</template>
